// Filter function to return everything but filenames starting with 'MT940_'
export const excludeGenericFileUploads = (files: Array<any>): Array<any> => {
  return (files || []).filter(
    (item) =>
      !item?.name?.startsWith('gfu_') && !item?.filename?.startsWith('gfu_')
  );
};

// Filter function to exclusively return Generic File Uploads (gfu_)
export const exclusivelyGenericFileUploads = (
  files: Array<any>
): Array<any> => {
  return (files || []).filter(
    (item) =>
      item?.name?.startsWith('gfu_') || item?.filename?.startsWith('gfu_')
  );
};

// Filter function to exclusively return filenames starting with 'currentRoute'
export const exclusivelyRetrieveGenericPrefix = (
  files: Array<any>,
  prefix: string
): Array<any> => {
  return (files || []).filter(
    (item) =>
      item?.name?.startsWith(`gfu_${prefix}_`) ||
      item?.filename?.startsWith(`gfu_${prefix}_`)
  );
};
